<template>
    <div class="inject-home" style="height: 100%">
        <div class="special-content">
            <div class="title">{{$t("edit.editActionTitles.specialEffectsSetting")}}</div>
            <div class="select-type" v-if="!isSetshine">
                <a-radio-group v-model="special_is_global" @change="onChange">
                    <a-radio :value="1">全局</a-radio>
                    <a-radio :value="0">{{$t("edit.editActionTitles.scene")}}</a-radio>
                </a-radio-group>
            </div>

            <div class="special-container">
                <div class="icon-list">
                    <div
                            class="icon-item"
                            @click="changeSpecialEffects(item.value)"
                            v-for="(item, index) in specialEffects"
                            :key="index"
                    >
                        <img
                                class="icon"
                                :class="{ 'icon-selected': item.value === currentSpecialType }"
                                :src="item.icon"
                        />
                        <div class="sys-title">{{ item.title }}</div>
                    </div>
                    <span style="font-size:12px; color: red;margin-bottom:10px;" v-if="isSetshine">{{$t("edit.editActionTitles.sunshinepreservation")}}</span>
                </div>
            </div>
            <div class="special-custom">
                <div><strong>{{$t("edit.editActionTitles.customeffects")}}</strong></div>
                <div class="custom-options">
                    <img v-if="customUrl" :src="customUrl"/>
                    <div v-else class="content-con-left">{{$t("descriptions.recommendSize")}}: 16*16</div>
                    <material-select style="padding:10px;" :type="1" @selected="handleSelectedImg">
                        <template slot="body">
                            <a-button type="primary" ghost >
                                {{$t("edit.sandboxs.selectImg2")}}
                            </a-button>
                        </template>
                    </material-select>
                </div>
            </div>

            <div style="padding: 10px 0">
                <a-checkbox
                        :checked="special_is_open === 1"
                        @change="isOpenEffects"
                >{{ $t("edit.openSpecial") }}
                </a-checkbox
                >
            </div>

            <div class="title" v-if="!special_is_global && !isSetshine">{{$t("edit.editActionTitles.scene")}}</div>
            <div class="scene-select" v-if="!special_is_global && !isSetshine">
                <ImgItem
                        :itemObj="value"
                        class="scene-item"
                        v-for="(value, k) in allScenes"
                        :key="k"
                        :selected="selectedScene"
                        @click.native="selectScene(value)"
                ></ImgItem>
            </div>
        </div>
        <div class="save-btns">
            <DoubleBtn @onClickSave="onClickSave" :showRight="0"></DoubleBtn>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import MaterialSelect from "@/components/MaterialSelect";
    import ImgItem from "../hotpoint/ImgItem";
    import DoubleBtn from "../DoubbleBtn";

    export default {
        name: "special-effects",
        components: {
            MaterialSelect,
            ImgItem,
            DoubleBtn,
        },
        data() {
            return {
                special_is_global: 1,
                special_is_open: 1,
                specialEffects: [
                    {
                        value: "rain",
                        title: this.$t("edit.lightRain"),
                        icon: require("../../assets/img/Light_Rain.png"),
                    }, //小雨
                    {
                        value: "midrain",
                        title: this.$t("edit.midRain"),
                        icon: require("../../assets/img/Moderate_Rain.png"),
                    }, //中雨
                    {
                        value: "heavyrain",
                        title: this.$t("edit.heavyRain"),
                        icon: require("../../assets/img/Heavy_Rain.png"),
                    }, //大雨
                    {
                        value: "defaultsnow",
                        title: this.$t("edit.lightSnow"),
                        icon: require("../../assets/img/Light_Snow.png"),
                    }, //小雪
                    {
                        value: "snowballs",
                        title: this.$t("edit.midSnow"),
                        icon: require("../../assets/img/Moderate_Snow.png"),
                    }, //中雪
                    {
                        value: "snowflakes",
                        title: this.$t("edit.heavySnow"),
                        icon: require("../../assets/img/Heavy_Snow.png"),
                    }, //大雪
                    {
                        value: "goldenstars",
                        title: this.$t("edit.stars"),
                        icon: require("../../assets/img/Stars.png"),
                    }, //下金星
                    {
                        value: "hearts",
                        title: this.$t("edit.hearts"),
                        icon: require("../../assets/img/Hearts.png"),
                    }, //下愛心
                    {
                        value: "money",
                        title: this.$t("edit.redEnvelope"),
                        icon: require("../../assets/img/Red_Envelope.png"),
                    }, //下紅包
                    {
                        value: "sunLight",
                        title: this.$t("edit.sunLight"),
                        icon: require("../../assets/img/sunlight.png"),
                    }, //太陽光
                ],
                currentSpecialType: "",
                currentEffects: {
                    custom_img: "",
                    is_display: 1,
                    is_global: 1,
                    special_type: "",
                    ath: 0,
                    atv: 0,
                },
                customUrl: "",
                selectedScene: [],
                isSetshine: false,
                //       custom_img: ""
                // is_display: 0
                // is_global: 1
                // special_type: "hearts"
            };
        },
        computed: {
            ...mapGetters(["vrbase", "currentScenesId", "userInfo"]),
            allScenes() {
                return this.vrbase.scenes;
            },
        },
        watch: {
            currentScenesId(newVal, oldVal) {
                this.handleInitListData();
            },
            'currentEffects.special_type': {
                handler: function (newVal, oldVal) {
                    this.isSetshine = newVal === 'sunLight';
                }
            }
        },
        created() {
            this.handleInitListData();
        },
        mounted() {
            this.$bus.$on("updateSunEffectSetting", (data) => {
                if (data.ath != this.currentEffects.ath || data.atv != this.currentEffects.atv) {
                    this.currentEffects.ath = data.ath;
                    this.currentEffects.atv = data.atv;
                }
            });
        },
        methods: {
            handleInitListData() {
                // console.log("this.vrbase.special_effects.is_global=", this.vrbase.special_effects)
                if (
                    this.vrbase &&
                    this.vrbase.special_effects &&
                    this.vrbase.special_effects.is_global == 0
                ) {
                    this.special_is_global = 0;
                } else {
                    this.special_is_global = 1;
                }

                /* if (this.special_is_global && this.vrbase.special_effects) {
                     const serveData = JSON.parse(
                         JSON.stringify(this.vrbase.special_effects)
                     );
                     this.currentEffects = {...this.currentEffects, ...serveData};
                 } else {
                     const serveData = JSON.parse(
                         JSON.stringify(
                             this.vrbase.scenes[this.currentScenesId]
                                 .special_effects
                         )
                     );
                     this.currentEffects = {...this.currentEffects, ...serveData};
                 }*/
                if(
                    this.vrbase &&
                    this.vrbase.scenes[this.currentScenesId].special_effects &&
                    Object.keys(this.vrbase.scenes[this.currentScenesId].special_effects).length
                ){
                    const serveData = JSON.parse(
                        JSON.stringify(
                            this.vrbase.scenes[this.currentScenesId].special_effects
                        )
                    );
                    this.currentEffects = {...this.currentEffects, ...serveData};
                }else{
                    if(this.special_is_global && this.vrbase.special_effects){
                        const serveData = JSON.parse(
                            JSON.stringify(this.vrbase.special_effects)
                        );
                        this.currentEffects = {...this.currentEffects, ...serveData};
                    }
                }
                this.customUrl = this.currentEffects.custom_img;
                this.currentSpecialType = this.currentEffects.special_type;
                this.special_is_open = this.currentEffects.is_display;
                this.updateKrpano(true);
            },
            onChange(e) {
                console.log("radio checked", e.target.value);
                this.currentEffects.is_global = this.special_is_global = e.target.value;
            },
            changeSpecialEffects(type) {
                this.currentEffects.special_type = this.currentSpecialType = type;
                this.currentEffects.custom_img = "";
                this.customUrl = "";

                this.updateKrpano();
            },
            handleSelectedImg(value) {
                this.customUrl = value.url;
                this.currentEffects.special_type = this.currentSpecialType = "custom";
                this.currentEffects.custom_img = this.customUrl;
                //update krpano
                this.updateKrpano();
            },
            updateKrpano(init = false) {
                if (this.currentEffects.special_type === "") return;
                if (this.currentEffects.special_type === "sunLight") {
                    if (init) {
                        addSunsetEffect({ath: this.currentEffects.ath, atv: this.currentEffects.atv})
                    } else {
                        const vh = getSceneViewAt();
                        addSunsetEffect({ath: vh.hlookat, atv: vh.vlookat});
                        this.currentEffects.ath = vh.hlookat
                        this.currentEffects.atv = vh.vlookat
                    }
                } else {
                    addsetSpecialEffects(
                        this.currentEffects.special_type,
                        this.currentEffects.custom_img
                    );
                }
            },
            isOpenEffects(e) {
                this.currentEffects.is_display = e.target.checked ? 1 : 0;
                this.special_is_open = this.currentEffects.is_display;
                if (this.currentEffects.is_display) {
                    //打開特效
                    this.currentEffects.special_type = this.currentSpecialType = "defaultsnow";
                    this.currentEffects.custom_img = "";
                    this.customUrl = "";
                    this.updateKrpano();
                } else {
                    //關閉特效
                    this.currentEffects.special_type = this.currentSpecialType = "";
                    this.currentEffects.custom_img = "";
                    this.customUrl = "";
                    removeSpecialEffects();
                }
            },
            selectScene(item) {
                const sceneId = item.scene_id;
                if (this.selectedScene.includes(item)) {
                    var index = this.selectedScene.indexOf(item);
                    if (index > -1) {
                        this.selectedScene.splice(index, 1);
                    }
                } else {
                    this.selectedScene.push(item);
                }
            },

            onClickSave() {
                const vrbase = this.vrbase;
                const setData = JSON.parse(
                    JSON.stringify(this.currentEffects)
                );
                if (this.currentEffects.special_type === 'sunLight') {
                    vrbase.scenes[this.currentScenesId].special_effects = setData;
                } else {
                    if (this.special_is_global === 1) {
                        console.log("1");
                        // const setData = JSON.parse(
                        //   JSON.stringify(this.currentEffects)
                        // );
                        vrbase.special_effects = setData;
                        for (let key in vrbase.scenes) {
                            vrbase.scenes[key].special_effects = setData;
                        }
                    } else {
                        console.log("0");
                        vrbase.special_effects.is_global = 0;
                        for (let key in vrbase.scenes) {
                            const scene = vrbase.scenes[key];
                            if (this.selectedScene.includes(scene)) {
                                scene.special_effects = setData;
                            }
                        }
                    }
                }
                console.log("===currentEffects===", this.currentEffects)
                this.$store.dispatch("setVRBase", vrbase);
                this.$store.dispatch("saveVRBase", {vrbase, showLoading: true,})
            },
        },
    };
</script>

<style lang="less" scoped>
    .title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: bold;
    }

    .special-container {
        margin-top: 10px;
    }

    .icon-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .icon-item {
            width: 68px;
            text-align: center;
            margin-bottom: 10px;
        }

        .icon {
            width: 50px;
            cursor: pointer;
        }

        .icon-selected {
            border: 2px solid #1890ff;
            border-radius: 8px;
        }
    }

    .content-con-left {
        width: 98px;
        height: 98px;
        border-radius: 6px;
        background-color: #3e4d66;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 14px;
        font-size: 12px;
        color: #ccc;
    }

    .custom-options {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            width: 98px;
            height: 98px;
            border-radius: 6px;
            margin-top: 14px;
            font-size: 12px;
            color: #ccc;
        }
        .selectBtn {
            color: #d485ff;
            border-color: #d485ff;
        }
        .selectBtn:hover{
            color: #e6b9ff;
            border-color: #e3b0ff;
        }
    }

    .scene-select {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .scene-item {
            margin-right: 5px;
        }
    }

    .special-content {
        height: calc(100% - 55px);
        // padding-top: 20px;
        overflow-y: auto;
    }

    .save-btns {
        padding: 10px 0;
        border-top: 1px solid #555;
    }
</style>
